/*
Copyright (c) 2018 Ady Levy
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import classnames from 'classnames';
import { translate, crudDelete, startUndoable } from 'ra-core';
import IconCancel from '@material-ui/icons/Cancel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Button } from 'react-admin';
import CircularProgress from '@material-ui/core/CircularProgress';
// import 'babel-polyfill';
// import fetch from 'cross-fetch';
const config = require('../../config.json');


const styles = (theme) => ({
  deleteButton: {
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: fade(theme.palette.error.main, 0.12),
      // Reset on mouse devices
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }
});

class ButtonVerifyForm extends Component {
  state = {
    showDialog: false,
    showDialog2: false,
    loading: false,
    msg: ''
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false, showDialog2: false});
  };
  
  handleConfirm = (event) => {
    event.preventDefault();
    this.setState({ loading: true, showDialog: false });
    const { record } = this.props;
    let data = {
      email: record.email,
      username: record.username
    }
    return fetch(config.API_URL + "/account/" + record.username + "/verify-link", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(res => {
      return res.json();
    })
    .then(mydata => {
      console.log("Informacion", mydata);
      try {
        this.setState({
          loading: false,
          showDialog2: true,
          msg: "Link de confirmación enviado con éxito."
        })
      } catch (e) {
        console.log(e);
        this.setState({
          showDialog2: true,
          msg: e,
          loading: false
        })
      }
    })
    .catch(err => {
      console.log(err);
      this.setState({
        showDialog2: true,
        msg: err.toString(),
        loading: false
      })
    })
  };

  render() {
    const { showDialog, loading, msg, showDialog2} = this.state;
    const { classes = {}, className } = this.props;
    return (
      <Fragment>
        <Button disabled={loading} onClick={this.handleClick} label="Link de verificación" className={classnames('ra-delete-button', classes.deleteButton, className)} key="button">
          <div style={{display: "flex", flexDirection: "row"}}>
            {(!loading) ? <VerifiedUserIcon />
              : <CircularProgress style={{marginLeft: '2%', width: "30px", height: "30px"}}/>
            }
          </div>
        </Button>
        <Dialog fullWidth open={showDialog} onClose={this.handleCloseClick} aria-label="¿Estás seguro de enviar el formulario?">
          <DialogTitle>Envío link de confirmación de cuenta</DialogTitle>
          <DialogContent>
            <div>
              Se enviará un correo al usuario con un link para verificar su cuenta sin utilizar el código.
              ¿Estás seguro de que deseas continuar?
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleConfirm} label="Enviar formulario" className={classnames('ra-delete-button', classes.deleteButton, className)} key="button">
              <VerifiedUserIcon />
            </Button>
            <Button label="Cancelar" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog fullWidth open={showDialog2} onClose={this.handleCloseClick} aria-label="Información de la transacción" style={{"white-space": "pre-line"}}>
          <DialogTitle>Información</DialogTitle>
          <DialogContent>
            <div>
              {msg}
            </div>
          </DialogContent>
          <DialogActions>
            <Button label="Confirmar" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

ButtonVerifyForm.propTypes = {
  basePath: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  dispatchCrudDelete: PropTypes.func.isRequired,
  label: PropTypes.string,
  record: PropTypes.object,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.func]),
  resource: PropTypes.string.isRequired,
  startUndoable: PropTypes.func,
  translate: PropTypes.func,
  undoable: PropTypes.bool
};

ButtonVerifyForm.defaultProps = {
  redirect: 'list',
  undoable: true
};

export default compose(
  connect(
    null,
    { startUndoable, dispatchCrudDelete: crudDelete }
  ),
  translate,
  withStyles(styles)
)(ButtonVerifyForm);